import api from '../utils/api'

const base = (businessId) => `/api/businesses/${businessId}/class-tickets`

// ---------- 範本 ----------

export const listClassTicketTemplates = (businessId, params = {}) =>
  api({
    url: `${base(businessId)}/templates`,
    method: 'get',
    params
  })

export const getClassTicketTemplate = (businessId, templateId) =>
  api({
    url: `${base(businessId)}/templates/${templateId}`,
    method: 'get'
  })

export const createClassTicketTemplate = (businessId, data) =>
  api({
    url: `${base(businessId)}/templates`,
    method: 'post',
    data
  })

export const updateClassTicketTemplate = (businessId, templateId, data) =>
  api({
    url: `${base(businessId)}/templates/${templateId}`,
    method: 'put',
    data
  })

export const deleteClassTicketTemplate = (businessId, templateId, data = {}) =>
  api({
    url: `${base(businessId)}/templates/${templateId}`,
    method: 'delete',
    data
  })

// ---------- 實例 ----------

export const listClassTickets = (businessId, params = {}) =>
  api({
    url: base(businessId),
    method: 'get',
    params
  })

/**
 * 堂票發放紀錄（依發放時間列出，附區間統計）。
 * params: { startDate, endDate (YYYY-MM-DD，店家時區), keyword, templateId,
 *           source (manual|checkout), issueType (sale|gift), salesPersonnel, page, pageSize }
 */
export const listClassTicketIssuances = (businessId, params = {}) =>
  api({
    url: `${base(businessId)}/issuances`,
    method: 'get',
    params
  })

export const getClassTicketDetail = (businessId, ticketId) =>
  api({
    url: `${base(businessId)}/${ticketId}`,
    method: 'get'
  })

export const issueClassTicket = (businessId, data) =>
  api({
    url: `${base(businessId)}/issue`,
    method: 'post',
    data
  })

export const redeemClassTicket = (businessId, ticketId, data) =>
  api({
    url: `${base(businessId)}/${ticketId}/redeem`,
    method: 'post',
    data
  })

export const refundClassTicket = (businessId, ticketId, data) =>
  api({
    url: `${base(businessId)}/${ticketId}/refund`,
    method: 'post',
    data
  })

export const voidClassTicket = (businessId, ticketId, data) =>
  api({
    url: `${base(businessId)}/${ticketId}/void`,
    method: 'post',
    data
  })

/**
 * 客戶的堂票。
 * params 可帶 { usableOnly: 1, serviceId } —— 結帳頁只要「現在扣得動、
 * 且適用這個服務」的票；客戶資料頁不帶，看全部（含已用完、已過期）。
 */
export const listClassTicketsByCustomer = (businessId, customerId, params = {}) =>
  api({
    url: `${base(businessId)}/by-customer/${customerId}`,
    method: 'get',
    params
  })

/**
 * 某位客戶的堂票使用歷程（跨他所有的票，依時間由新到舊）。
 * 客戶資料頁用來像預約紀錄一樣一條一條列出來。
 */
export const listClassTicketUsagesByCustomer = (
  businessId,
  customerId,
  params = {}
) =>
  api({
    url: `${base(businessId)}/usages/by-customer/${customerId}`,
    method: 'get',
    params
  })

export const listClassTicketsByOrder = (businessId, orderId) =>
  api({
    url: `${base(businessId)}/by-order/${orderId}`,
    method: 'get'
  })

// 匯出 CSV：直接以 fetch + blob 觸發下載
export const exportClassTicketsUrl = (businessId, type = 'tickets') =>
  `${base(businessId)}/export?type=${encodeURIComponent(type)}`

// ---------- 堂票銷售抽成設定 ----------

const commissionBase = (businessId) =>
  `/api/businesses/${businessId}/class-ticket/commission`

export const getClassTicketCommission = (businessId) =>
  api({
    url: commissionBase(businessId),
    method: 'get'
  })

export const updateClassTicketCommission = (businessId, data) =>
  api({
    url: commissionBase(businessId),
    method: 'put',
    data
  })
